import { Outlet } from 'react-router-dom';
import { useAppSetup } from '../../../hooks/setup/useAppSetup';
import { useAppSelector } from '../../../hooks/store/useStore';
import { Loading } from '../../common/loading/Loading';

export const AppSetup = () => {
  useAppSetup();

  const isVirtualNumberLoading = useAppSelector((state) => state.virtualNumberLoading.isLoading);

  return (
    <>
      <Loading loading={isVirtualNumberLoading} />
      <Outlet />
    </>
  );
};
